import React, { useState, useEffect } from "react";
import GYAxios from "./../../util/GYAxios";
import { checkIfArray, checkIfObjectHasKeys } from "./../../util/checking";
import Noti from "../../util/noti";
import "echarts/lib/chart/pie";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import { Container, Row, Col } from "react-bootstrap";
import moment from "moment-timezone";
import { abbGreek } from "../../util/formatter";
import ReactEcharts from "echarts-for-react";
import LoaderGraph from "../general/LoaderGraph";
import db_style from "./dashboard.module.css";
import { useUser } from "./../../util/user";

export const Dashboard = (props) => {
	const [userType, setUserType] = useState(null);
	const [stateProcess, setStateProcess] = useState(false);

	const [uriP10, setUriP10] = useState(null);

	const [totalC, setTotalC] = useState(null);
	const [totalOpSite, setTotalOpSite] = useState(0);

	const [todaySolarProd, setTodaySolarProd] = useState(0);
	const [todayGridProd, setTodayGridProd] = useState(0);

	const [fetchedInstant, setFetchedInstant] = useState([]);
	const [instantGrid, setInstantGrid] = useState(0);
	const [instantSolar, setInstantSolar] = useState(0);
	const [instantTime, setInstantTime] = useState(null);

	const [p10Power, setP10Power] = useState([]);
	const [stateP10, setStateP10] = useState(false);

	const [graphPower, setGraphPower] = useState(null);

	const [accruedSolar, setAccruedSolar] = useState(null);
	const [accruedGrid, setAccruedGrid] = useState(null);
	const [stateAccrued, setStateAccrued] = useState(false);

	const [clientLogo, setClientLogo] = useState(null);

	const [p10GraphConfig, setP10GraphConfig] = useState(null);

	// adding for any users doesnt want to use the dashboard graph 
	const user = useUser();
	const roles = user?.roles; // return array of roles
	const role_hidden_exist = (roles != null && roles.includes("overview:Dashboard:_hidden"));

	const pushToP10Power = (new_array) => {
		const new_value = new_array < 0 ? 0 : new_array;
		setP10Power((prev) => [...prev, new_value]);
	};

	const graphOption = (data) => {
		const colours = ["#86bc25", "#f28a10"];
		return {
			title: {
				text: "Power Today",
				x: "left",
				align: "right",
				left: 30,
			},
			color: colours,
			tooltip: {
				trigger: "axis",
				axisPointer: {
					animation: true,
					type: "cross",
				},
			},
			toolbox: {
				feature: {
					saveAsImage: {},
				},
			},
			legend: {
				data: ["Solar Power", "Grid Power"],
				x: "center",
			},
			dataZoom: [
				{
					type: "slider",
					filterMode: "filter",
				},
			],
			grid: {
				top: 70,
				bottom: 70,
				left: "15%",
				right: "5%",
			},
			xAxis: [
				{
					type: "category",
					axisTick: {
						alignWithLabel: true,
					},
					axisLine: {
						onZero: false,
						lineStyle: {
							color: colours[0],
						},
					},
					axisTick: {
						show: true,
					},
					data: data.timeData,
					boundaryGap: false,
				},
			],
			yAxis: [
				{
					type: "value",
					name: "kW",
					axisLine: {
						show: true,
					},
					axisTick: {
						show: true,
					},
				},
			],
			series: [
				{
					name: "Solar Power",
					type: "line",
					stack: "总量",
					areaStyle: { normal: {} },
					data: data.solar,
				},
				{
					name: "Grid Power",
					type: "line",
					stack: "总量",
					areaStyle: { normal: {} },
					data: data.grid,
				},
			],
		};
	};

	function groupByArray(xs, key) {
		return xs.reduce(function (rv, x) {
			let v = key instanceof Function ? key(x) : x[key];
			let el = rv.find((r) => r && r.key === v);
			if (el) {
				el.values.push(x);
			} else {
				rv.push({ key: v, values: [x] });
			}
			return rv;
		}, []);
	}

	const pushToInstant = (new_array) => {
		setFetchedInstant((prev) => [...prev, new_array]);
	};

	async function fetchData(uri) {
		return await GYAxios.get(uri)
			.then((res) => {
				try {
					if (res.data.error !== undefined) {
						console.log(`${uri} ${res.data.error}`);
						return null;
					} else {
						if (checkIfArray(res.data)) {
							return res.data;
						} else {
							console.log(`${uri} does not return an array`);
							return null;
						}
					}
				} catch (e) {
					console.log(`${uri} ${e}`);
					return null;
				}
			})
			.catch((err) => {
				console.log(`${uri} ${err}`);
				return null;
			});
	}

	useEffect(() => {
		if (checkIfObjectHasKeys(props.user)) {
			if (props.user.type === undefined || props.user.type === "") {
				Noti.create({
					type: "e",
					msg: "Error with user info.",
				});
				return;
			}

			if (props.user?.type === "admin") {
				setUserType(0);
			} else if (
				(props.user?.type === "client_multi" &&
					props.user.id.split(",").length > 10) ||
				props.user?.type === "client"
			) {
				setUserType(1);
			} else if (
				props.user?.type === "client_multi" &&
				props.user.id.split(",").length < 11
			) {
				setUserType(2);
			} else {
				Noti.create({
					type: "e",
					msg: "Type of user is not allowed to be here.",
				});
				return;
			}
		}
	}, [props.user]);

	useEffect(() => {
		if (props.clientLogo !== null && props.clientLogo !== "") {
			setClientLogo(props.clientLogo);
		}
	}, [props.clientLogo]);

	useEffect(() => {
		if (userType !== null && checkIfArray(props.siteData) && !stateProcess && !role_hidden_exist) {
			processing4thArray(props.siteData[3].data);

			if (userType === 2) {
				processing1stArray(props.siteData[0].data);
				const uri_accrued_prod = `overview_dashboard/accrued_prod/multi/${props.user.id}`;
				fetchData(uri_accrued_prod).then(function (fetchedProd) {
					if (fetchedProd === null) {
						Noti.create({
							type: "e",
							msg: "Something is wrong.",
						});
						return;
					}

					setAccruedSolar(abbGreek(fetchedProd[0].solar, "kWh"));
					setAccruedGrid(abbGreek(fetchedProd[0].grid, "kWh"));
					setStateAccrued(true);
				});
			}

			if (userType === 1 || userType === 0) {
				// taking instant in p10_calc
				if (userType === 0) {
					fetchData(`/overview_dashboard/p10_power?slug=GY`).then(function (
						fetchedPower
					) {
						if (fetchedPower === null) {
							Noti.create({
								type: "e",
								msg: "Something is wrong.",
							});
							return;
						}

						setGraphPower(fetchedPower);
						setInstantGrid(
							abbGreek(fetchedPower[fetchedPower.length - 1].grid, "kW")
						);
						setInstantSolar(
							abbGreek(fetchedPower[fetchedPower.length - 1].solar, "kW")
						);

						const timeSeperated =
							fetchedPower[fetchedPower.length - 1].timeData.split(":");
						const floor_min =
							Math.floor(parseFloat(timeSeperated[1]) / 10) * 10;
						const minutes = floor_min === 0 ? "00" : floor_min;
						const hour = timeSeperated[0];
						setInstantTime(hour + ":" + minutes);
					});

					fetchData(`/overview_dashboard/accrued_prod_gy`).then(function (
						fetchedProd
					) {
						if (fetchedProd === null) {
							Noti.create({
								type: "e",
								msg: "Something is wrong.",
							});
							return;
						}

						setAccruedSolar(abbGreek(fetchedProd[0].solar, "kWh"));
						setStateAccrued(true);
					});
				} else {
					const uri_slug =
						props.user?.type === "client_multi"
							? `client/multi/${props.user.id.split(",")[0]}`
							: `client/${props.user.id}`;
					const uri_accrued_prod =
						props.user?.type === "client_multi"
							? `overview_dashboard/accrued_prod/multi/${props.user.id}`
							: `overview_dashboard/accrued_prod/hq/${props.user.id}`;
					fetchData(uri_slug).then(function (fetchedSlug) {
						if (fetchedSlug === null) {
							Noti.create({
								type: "e",
								msg: "Something is wrong.",
							});
							return;
						}

						fetchData(
							`/overview_dashboard/p10_power?slug=${encodeURIComponent(
								fetchedSlug[0].slug
							)}`
						).then(function (fetchedPower) {
							if (fetchedPower === null) {
								Noti.create({
									type: "e",
									msg: "Something is wrong.",
								});
								return;
							}

							setGraphPower(fetchedPower);
							setInstantTime(
								moment(
									fetchedPower[fetchedPower.length - 1].timeData,
									"HHmm"
								).format("HH:mm")
							);
							setInstantGrid(
								abbGreek(fetchedPower[fetchedPower.length - 1].grid, "kW")
							);
							setInstantSolar(
								abbGreek(fetchedPower[fetchedPower.length - 1].solar, "kW")
							);
						});
					});

					fetchData(uri_accrued_prod).then(function (fetchedProd) {
						if (fetchedProd === null) {
							Noti.create({
								type: "e",
								msg: "Something is wrong.",
							});
							return;
						}

						setAccruedSolar(abbGreek(fetchedProd[0].solar, "kWh"));
						setAccruedGrid(abbGreek(fetchedProd[0].grid, "kWh"));
						setStateAccrued(true);
					});
				}
			}
			setStateProcess(true);
		}
	}, [userType, props.siteData, role_hidden_exist]);

	function processing4thArray(array) {
		const total_capacity = array.reduce(function (prev, current) {
			if (current.power !== null) return prev + current.power;
			else return prev + 0;
		}, 0); // Total plant capacity
		const number_of_sites = array.length; // Operating sites
		const solar_total = array.reduce(function (prev, current) {
			if (current.solar_total !== null) return prev + current.solar_total;
			else return prev + 0;
		}, 0); // Total Solar Prod Today
		const grid_total = array.reduce(function (prev, current) {
			if (current.grid_total !== null) return prev + current.grid_total;
			else return prev + 0;
		}, 0); // Total Grid Prod Today

		setTotalC(abbGreek(total_capacity, "kWp"));
		setTotalOpSite(number_of_sites);
		setTodaySolarProd(abbGreek(solar_total, "kWh"));
		setTodayGridProd(abbGreek(grid_total, "kWh"));
	}

	function processing1stArray(array) {
		const table_names = array.map((v) => v.table_name);
		const todayDate = moment().format("YYYY-MM-DD");
		const todayTime = moment().format("HH:mm:ss");

		const array_uri_p10 = [];

		for (let index = 0; index < table_names.length; index++) {
			const table_name = table_names[index];

			const uri_power_p10 = `overview_dashboard/power_p10/${todayDate}?ts=${encodeURIComponent(
				table_name
			)}`;
			array_uri_p10.push(uri_power_p10);

			const uri_instant = `overview_dashboard/instantPower/${todayDate}/${todayTime}?ts=${encodeURIComponent(
				table_name
			)}`;

			fetchData(uri_instant).then(function (instant) {
				if (instant === null) {
					let temp_instant = {
						time: moment().subtract(15, "minute").format("HH:mm:ss"),
						grid: 0,
						solar: 0,
					};

					pushToInstant(temp_instant);
				} else pushToInstant(instant);
			});
		}

		setUriP10(array_uri_p10);
	}

	useEffect(() => {
		if (checkIfArray(uriP10)) {
			for (let i = 0; i < uriP10.length; i++) {
				fetchData(uriP10[i]).then(function (power_p10) {
					if (power_p10 === null) {
						Noti.create({
							type: "w",
							msg: "Error with fetching solar power and grid power P10",
						});

						return;
					}

					pushToP10Power(power_p10);
				});
			}
		}
	}, [uriP10]);

	useEffect(() => {
		if (checkIfArray(p10Power) && checkIfArray(uriP10)) {
			if (p10Power.length === uriP10.length) setStateP10(true);
		}
	}, [p10Power]);

	useEffect(() => {
		if (stateP10) {
			const flat = [].concat(
				...p10Power.map((v) => {
					return v;
				})
			);

			const groupData = groupByArray(flat, "timeData").map((v) => {
				if (checkIfArray(v.values)) {
					const solar_power = v.values.reduce(function (prev, current) {
						if (current.solar_power !== null) return prev + current.solar_power;
						else return prev + 0;
					}, 0);
					const grid_power = v.values.reduce(function (prev, current) {
						if (current.grid_power !== null) return prev + current.grid_power;
						else return prev + 0;
					}, 0);

					return {
						timeData: v.key,
						solar: parseFloat(solar_power).toFixed(2),
						grid: parseFloat(grid_power).toFixed(2),
					};
				} else {
					return null;
				}
			});

			const graphData = groupData.filter(
				(v) => moment(v.timeData, "HH:mm").minutes() % 10 === 0
			);

			const nullData = graphData.filter((v) => v === null);
			if (nullData.length === 0) {
				setGraphPower(
					graphData.sort((a, b) =>
						moment(a.timeData, "HHmm").diff(moment(b.timeData, "HHmm"))
					)
				);
			} else {
				Noti.create({
					type: "e",
					msg: "Something is wrong.",
				});
				return;
			}
		}
	}, [stateP10]);

	useEffect(() => {
		if (fetchedInstant.length === totalOpSite && totalOpSite !== 0) {
			// finish sum of latest p10 solar power
			const flattenedInstant = [].concat(
				...fetchedInstant.map((v) => {
					return v;
				})
			);

			for (let i = 0; i < flattenedInstant.length; i++) {
				const time = flattenedInstant[i]?.time;
				if (time !== undefined && time !== null) {
					const timeSeperated = time.split(":");
					const floor_min = Math.floor(parseFloat(timeSeperated[1]) / 10) * 10;
					const minutes = floor_min === 0 ? "00" : floor_min;
					const hour = timeSeperated[0];
					setInstantTime(hour + ":" + minutes);
					break;
				}
			}

			const instant_solar = flattenedInstant.reduce(function (prev, current) {
				if (current?.solar !== null) return prev + current?.solar;
				else return prev + 0;
			}, 0); // Total Instant Solar Power
			const instant_grid = flattenedInstant.reduce(function (prev, current) {
				if (current?.grid !== null) return prev + current?.grid;
				else return prev + 0;
			}, 0); // Total Instant Grid Power

			setInstantGrid(abbGreek(instant_grid, "kW"));
			setInstantSolar(abbGreek(instant_solar, "kW"));
		}
	}, [fetchedInstant]);

	useEffect(() => {
		if (graphPower !== null) {
			const timeData = graphPower.map((v) => moment(
				v.timeData,
				"HHmm"
			).format("HH:mm"));
			const solar = graphPower.map((v) => {
				return v.solar > 0 ? v.solar : 0;
			});
			const grid = graphPower.map((v) => {
				return v.grid > 0 ? v.grid : 0;
			});
			const data = { timeData, solar, grid };
			setP10GraphConfig(graphOption(data));
		}
	}, [graphPower]);

	return (
		role_hidden_exist ? <Container fluid className={`${db_style["ov_db"]}`}>
			<Row className={`${db_style["wrapper"]}`}>
				<Row>
					<Row className={`${db_style["logo"]}`}>
						<Col md={"3"}></Col>
						<Col md={"6"}>
							<img src={clientLogo} alt="logo" />
						</Col>
						<Col md={"3"}></Col>
					</Row>
				</Row> </Row> </Container> :
			<Container fluid className={`${db_style["ov_db"]}`}>
				{totalOpSite > 0 &&
					totalC &&
					instantTime &&
					stateAccrued ? (
					<Row className={`${db_style["wrapper"]}`}>
						{userType === 0 ? (
							<Row>
								<Row className={`${db_style["general"]}`}>
									<Col md={"3"}></Col>
									<Col md={"6"}>
										<h4 className={`${db_style["title"]}`}>OVERVIEW DASHBOARD</h4>
									</Col>
									<Col md={"3"}></Col>
								</Row>
								<Row className={`${db_style["cards_section"]}`}>
									<Col md={"3"} className={`${db_style["card_wrapper"]}`}>
										<div className={`${db_style["card"]}`}>
											<h5 className={`${db_style["date"]} ${db_style["align_self"]}`}>
												{moment().format("DD MMM YYYY")}
											</h5>
											<div className={`${db_style["align_self"]}`}>
												Accrued Solar Production:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{accruedSolar}
												</span>
											</div>
										</div>
									</Col>
									<Col md={"3"} className={`${db_style["card_wrapper"]}`}>
										<div className={`${db_style["card"]}`}>
											<div className={`${db_style["align_self"]}`}>
												Operating Plants:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{totalOpSite}
												</span>
											</div>
											<div className={`${db_style["align_self"]}`}>
												Total capacity:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{totalC}
												</span>
											</div>
										</div>
									</Col>
									<Col md={"3"} className={`${db_style["card_wrapper"]}`}>
										<div className={`${db_style["card"]}`}>
											<div className={`${db_style["align_self"]}`}>
												Solar Power @{instantTime}:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{instantSolar}
												</span>
											</div>
											<div className={`${db_style["align_self"]}`}>
												Grid Power @{instantTime}:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{instantGrid}
												</span>
											</div>
										</div>
									</Col>
									<Col md={"3"} className={`${db_style["card_wrapper"]}`}>
										<div className={`${db_style["card"]}`}>
											<div className={`${db_style["align_self"]}`}>
												Today Solar Production:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{todaySolarProd}
												</span>
											</div>
											<div className={`${db_style["align_self"]}`}>
												Today Grid Consumption:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{todayGridProd}
												</span>
											</div>
										</div>
									</Col>
								</Row>

								<Row
									className={`${db_style["wrapper"]} ${db_style["space-top"]}`}
								>
									{p10GraphConfig && (
										<div>
											<ReactEcharts
												option={p10GraphConfig}
												notMerge={true}
												lazyUpdate={true}
												className={`${db_style["graph"]}`}
											/>
										</div>
									)}
								</Row>
							</Row>
						) : (
							<Row>
								<Row className={`${db_style["logo"]}`}>
									<Col md={"3"}></Col>
									<Col md={"6"}>
										<img src={clientLogo} alt="logo" />
									</Col>
									<Col md={"3"}></Col>
								</Row>
								<Row className={`${db_style["general"]}`}>
									<Col md={"3"}></Col>
									<Col md={"6"}>
										<h4 className={`${db_style["title"]}`}>OVERVIEW DASHBOARD</h4>
										<div>
											<h4 className={`${db_style["date"]}`}>
												{moment().format("DD MMM YYYY")}
											</h4>
										</div>
									</Col>
									<Col md={"3"}></Col>
								</Row>
								<Row>
									<Col md={"3"} className={`${db_style["card_wrapper"]}`}>
										<div className={`${db_style["card"]}`}>
											<div>
												Operating Plants:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{totalOpSite}
												</span>
											</div>
											<div>
												Total capacity:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{totalC}
												</span>
											</div>
										</div>
									</Col>
									<Col md={"3"} className={`${db_style["card_wrapper"]}`}>
										<div className={`${db_style["card"]}`}>
											<div>
												Solar Power @{instantTime}:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{instantSolar}
												</span>
											</div>
											<div>
												Grid Power @{instantTime}:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{instantGrid}
												</span>
											</div>
										</div>
									</Col>
									<Col md={"3"} className={`${db_style["card_wrapper"]}`}>
										<div className={`${db_style["card"]}`}>
											<div>
												Today Solar Production:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{todaySolarProd}
												</span>
											</div>
											<div>
												Today Grid Consumption:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{todayGridProd}
												</span>
											</div>
										</div>
									</Col>
									<Col md={"3"} className={`${db_style["card_wrapper"]}`}>
										<div className={`${db_style["card"]}`}>
											<div>
												Accrued Solar Production:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{accruedSolar}
												</span>
											</div>
											<div>
												Accrued Grid Consumption:{" "}
												<span className={`${db_style["emphasised"]}`}>
													{accruedGrid}
												</span>
											</div>
										</div>
									</Col>
								</Row>

								<Row
									className={`${db_style["wrapper"]} ${db_style["space-top"]}`}
								>
									{p10GraphConfig && (
										<div>
											<ReactEcharts
												option={p10GraphConfig}
												notMerge={true}
												lazyUpdate={true}
												className={`${db_style["graph"]}`}
											/>
										</div>
									)}
								</Row>
							</Row>
						)}
					</Row>
				) : (
					<LoaderGraph />
				)}
				<Noti />
			</Container>
	);
};
